<template>
  <div class="root-page">
    <component v-if="page" :data="data" :is="page" ></component>
  </div>
</template>

<script>
import promo from './Pages/Promo.vue'
import all from './Pages/All.vue'
import ApiClient from '../api/index'
import completeLoad from '../mixins/completeLoad'
import $ from 'jquery'

export default {
  components: {
    promo,
    all
  },

  data () {
    return {
      page: null,
      data: [],
      response: [],
      layouts: ['promo', 'all'],
      path: this.$route.path ? this.$route.path : null,
    }
  },

  mixins: [completeLoad],

  created () {
    this.fxLogo()
    this.toTop()
    this.requestPage()
  },

  methods: {
    requestPage () {
      ApiClient.page(this.path)
        .then(response => {
          this.setPage(response.data.page, response.data)
        })
    },

    setTitle(title) {
      document.title = title + ' | ' + drupalSettings.sitename
    },

    setPage (name, data) {
      this.page = false
      if (this.layouts.indexOf(name) >= 0) {
        this.page = name
        this.data = data
        this.setTitle(data.title)
        this.updateBackground()
        console.log(this.data)
        this.setBodyClasses(['page-node-type-' + this.data.bundle])
      } else {
        ApiClient.drupal(this.path)
          .then(response => {
            this.page = 'all'
            this.data = response.data
          })
      }

      this.data = data
    },

    updateBackground () {
      if ($(window).width() < 1018 && this.data.background_mobile) {
        this.changeBackground(this.data.background_mobile, 'fade')
      } else {
        this.changeBackground(this.data.background, 'fade')
      }
    }
  },

  watch: {
    data (data) {
      this.toTop()
      this.updateBackground()
    },
  }
}
</script>

<style lang="scss">
.root-page {
  height: 100%;
  .page-content {
    width: 100%;
    transition: all .5s ease;
  }

  .left {
    padding: 0px 50px 0px 130px;
    height: 100%;
  }
}

</style>